import { useEffect, useState } from "react";

// Has this browser ever held a session? Students and tutors hunt for a way in;
// first-time visitors need a single obvious next step. Knowing which we're
// looking at lets the header adapt silently, with no "are you a student?"
// question anywhere on the page.
//
// Read in an effect rather than during render so prerendered and hydrated
// markup agree — the server has no localStorage, so both start as "new".
export const useVisitor = () => {
  const [known, setKnown] = useState(false);
  const [signedIn, setSignedIn] = useState(false);

  useEffect(() => {
    try {
      const token = localStorage.getItem("access_token");
      const expiry = parseInt(localStorage.getItem("token_expiration"), 10);
      const live = Boolean(token) && (!expiry || expiry > Date.now());
      setSignedIn(live);
      setKnown(live || localStorage.getItem("fs_has_account") === "1");
    } catch {
      // Private mode or blocked storage — treat as a first-time visitor.
    }
  }, []);

  return { known, signedIn };
};

export default useVisitor;
